import Router from 'vue-router';

/**
 * Check if a return path is invalid (dashboard, login, or onboarding pages).
 * These paths should not be used as return paths to avoid redirect loops.
 */
export function isInvalidReturnPath(path: string | null | undefined): boolean {
  if (!path) return true;
  const normalizedPath = path.split('?')[0];
  return /^\/(account\/(seekers|providers)\/dashboard|login|sitter\/(signup|verify_identity|background_check|complete)|corporate-onboarding)/.test(
    normalizedPath
  );
}

/**
 * Navigate to the returnPath from query params, or to the default path if returnPath
 * is missing or invalid. Handles both relative paths and full URLs by extracting the path from URLs.
 */
export function navigateToReturnPath(router: Router, defaultPath: string): void {
  const returnPath = router.currentRoute.query.returnPath as string | undefined;

  if (returnPath && !isInvalidReturnPath(returnPath)) {
    let pathToNavigate = returnPath;

    try {
      const url = new URL(returnPath);
      pathToNavigate = url.pathname + url.search;
    } catch {
      pathToNavigate = returnPath;
    }

    router.push(pathToNavigate);
  } else {
    router.push(defaultPath);
  }
}
